module.exports = __webpack_public_path__ + "img/approval-1.e08a6aed.png";